import { formatTenorUnit } from 'components/dashboard/Dashboard.helper';
import { CurrencyFlagIcon } from 'components/shared/WithCountryFlag';
import { useSPIntl } from 'hooks/useIntl';
import { FC } from 'react';
import type { TenorDetails } from 'state/quotes/details/details.model';

const Separator: FC = () => <span className="mx-2">|</span>;
export const AdditionalQuoteInfo: FC<{ currency?: string; maturityDate?: string; tenor?: TenorDetails }> = ({
  currency,
  maturityDate,
  tenor,
}) => {
  const { formatMessage, formatDisplayedDate } = useSPIntl();

  return (
    <div className="d-flex justify-content-start align-items-center mx-3 py-2 mb-2 border-bottom border-secondary-alpha-lg text-secondary">
      {currency && (
        <>
          <CurrencyFlagIcon currency={currency} className="me-2 border border-secondary" />
          <span title={formatMessage({ id: 'form.Currency' })}>{currency}</span>
        </>
      )}
      {currency !== undefined && maturityDate !== undefined && <Separator />}
      {maturityDate !== undefined && (
        <label className="mb-0" title={formatMessage({ id: 'quoteDetails.MaturityDate' })}>
          {formatDisplayedDate(maturityDate)}
        </label>
      )}
      {maturityDate !== undefined && tenor !== undefined && <Separator />}
      {tenor !== undefined && (
        <label className="mb-0" title={formatMessage({ id: 'dashboard.tenor' })}>
          <span className="me-1">{tenor.value}</span>
          {formatTenorUnit(tenor.unit, formatMessage, tenor.value)}
        </label>
      )}
    </div>
  );
};
AdditionalQuoteInfo.displayName = 'AdditionalQuoteInfos';
